import {createFragmentContainer, graphql} from 'react-relay';
import React from 'react';
import SignUpModal from './signup_modal';

const standaloneSignUpModal = props => {
	const {
		closeModal,
		plans,
		addons,
		viewer: {missionControlData},
	} = props;

	return <SignUpModal closeModal={closeModal} company={missionControlData.trialsList[0]} plans={plans} addons={addons} />;
};

const standaloneSignUpModalQuery = graphql`
	query standaloneSignupModal_Query($companyId: ID) {
		viewer {
			actualPersonId
			component(name: "signup_modal_standalone")
			...standaloneSignupModal_viewer @arguments(companyId: $companyId)
		}
	}
`;

export {standaloneSignUpModalQuery};

export default createFragmentContainer(standaloneSignUpModal, {
	viewer: graphql`
		fragment standaloneSignupModal_viewer on Viewer @argumentDefinitions(companyId: {type: "ID"}) {
			id
			missionControlData {
				trialsList(companyId: $companyId) {
					companyId
					companyName
					jiraEnabled
					minimumSeats
					minimumVirtualSeats
					users
					virtualUsers
					country
					trialEndDay
					trialEndMonth
					trialEndYear
					street
					zip
					city
					vatId
					contactName
					contactEmail
					contactPhone
					trialExpired
					persons {
						id
						active
						role {
							id
							name
						}
						firstName
						lastName
						fullName
						profilePictureId
						email
						client {
							id
						}
					}
				}
			}
		}
	`,
});
